import { Main } from "./Main";
import { Mock } from "./Mock";

export const Composition = {
    Mock: () => <Mock />,
    Main: () => <Main />,
}